import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchPrice, fetchPriceCreate, editPrice,
} from "Actions/Admin/Strech/PriceActions";



/**
 * The Strech Price Edit Dialog
 */
class PriceEdit extends React.Component {
    // The Initial Data
    initialData = {
        strechPriceID : 0,
        strechID      : 0,
        priceID       : 0,
        dues          : "",
        price         : "",
        showPrice     : 1,
        isPromotion   : 0,
        promotionEnd  : "",
        paymentLink   : "",
        status        : Status.getID("ACTIVE"),
        observations  : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, strechID, fetchPrice, fetchPriceCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchPrice(elemID);
                loading = true;
            // Load edit data
            } else if (strechID) {
                fetchPriceCreate(strechID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, strechID };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        const { priceData } = this.props;
        let fields = { [name] : value };
        let errors = { [name] : ""    };

        if (name === "priceID") {
            const elem   = Utils.getValue(priceData, "priceID", value);
            fields.dues  = elem.dues  || "";
            fields.price = elem.price || "";
            errors.dues  = "";
            errors.price = "";
        }

        this.setState({
            data   : { ...this.state.data,   ...fields },
            errors : { ...this.state.errors, ...errors },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editPrice(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, prices } = this.props;
        const { data, loading, errors         } = this.state;

        const showPromotion    = Boolean(data.showPrice && Number(data.dues) === 1);
        const showPromotionEnd = Boolean(showPromotion && data.isPromotion);

        return <EditDialog
            open={open}
            icon="price"
            title={!!elemID ? "PRICES_EDIT_TITLE" : "PRICES_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="priceID"
                label="PRICES_SINGULAR"
                helperText="PRICES_NEW_HELP"
                value={data.priceID}
                error={errors.priceID}
                onChange={this.handleChange}
                options={prices}
                noneText="PRICES_NEW_PRICE"
                withNone
                isRequired
                shrinkLabel
            />
            <InputField
                type="number"
                name="dues"
                label="PRICES_DUES"
                value={data.dues}
                error={errors.dues}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="number"
                name="price"
                icon="money"
                label="PRICES_PRICE"
                value={data.price}
                error={errors.price}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="toggle"
                name="showPrice"
                label="PRICES_SHOW"
                value={data.showPrice}
                onChange={this.handleChange}
            />
            <InputField
                isHidden={!showPromotion}
                type="toggle"
                name="isPromotion"
                label="PRICES_IS_PROMOTION"
                value={data.isPromotion}
                error={errors.isPromotion}
                onChange={this.handleChange}
            />
            <InputField
                isHidden={!showPromotionEnd}
                type="date"
                name="promotionEnd"
                label="PRICES_PROMOTION_END"
                value={data.promotionEnd}
                error={errors.promotionEnd}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                isHidden={!data.showPrice}
                name="paymentLink"
                label="PRICES_PAYMENT_LINK"
                value={data.paymentLink}
                error={errors.paymentLink}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getSelect("PRICE")}
                withNone
                isRequired
                shrinkLabel
            />
            <InputField
                type="textarea"
                name="observations"
                label="GENERAL_OBSERVATIONS"
                value={data.observations}
                onChange={this.handleChange}
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchPrice       : PropTypes.func.isRequired,
        fetchPriceCreate : PropTypes.func.isRequired,
        editPrice        : PropTypes.func.isRequired,
        open             : PropTypes.bool.isRequired,
        onClose          : PropTypes.func.isRequired,
        onSubmit         : PropTypes.func.isRequired,
        edition          : PropTypes.number.isRequired,
        prices           : PropTypes.array.isRequired,
        priceData        : PropTypes.array.isRequired,
        elem             : PropTypes.object.isRequired,
        elemID           : PropTypes.number,
        strechID         : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition   : state.strechPrice.edition,
            prices    : state.strechPrice.prices,
            priceData : state.strechPrice.priceData,
            elem      : state.strechPrice.elem,
        };
    }
}

export default connect(PriceEdit.mapStateToProps, {
    fetchPrice, fetchPriceCreate, editPrice,
})(PriceEdit);
